import IconButton, {
	IconButtonProps,
} from 'src/components/primitives/IconButton/IconButton';
import { TOP_BAR_DEFAULT_BUTTON_CLASSNAME } from 'src/components/TopBar/consts';
import { cj } from 'src/utils/classNames';
import { SetRequired } from 'type-fest';

type Props = Omit<SetRequired<IconButtonProps, 'icon'>, 'children' | 'size'>;

export default function TopBarIconButton({
	icon: Icon,
	className,
	...props
}: Props) {
	return (
		<IconButton
			size="md"
			className={cj(TOP_BAR_DEFAULT_BUTTON_CLASSNAME, className)}
			icon={Icon}
			{...props}
		/>
	);
}
